import AsyncStorage from "@react-native-async-storage/async-storage";
import { atomFamily, atomWithStorage, createJSONStorage } from "jotai/utils";

export const teeSheetSelectedCourseIdsByFacility = atomFamily(
  (facilityID: string) => {
    const storage = createJSONStorage<string[] | null>(() => AsyncStorage);
    return atomWithStorage<string[] | null>(
      `teeSheetCourseFilter:${facilityID}`,
      null,
      storage,
      { getOnInit: true }
    );
  }
);
